import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "g-row g-row--align_center g-row--justify_center g-row--space_none relative" }
const _hoisted_2 = {
  key: 0,
  class: "g-cell g-cols g-cols--auto"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "g-cell g-cols" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "sidebar-back-to-site-wrap"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "sidebar-back-to-site__text" }
const _hoisted_11 = { class: "cabinet-sidebar-menu-section__element" }
const _hoisted_12 = { class: "cabinet-sidebar-menu-element__icon" }
const _hoisted_13 = { class: "cabinet-sidebar-menu-element__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_i_external_link = _resolveComponent("i-external-link")!
  const _component_CabinetSidebarMenu = _resolveComponent("CabinetSidebarMenu")!
  const _component_CabinetSidebar = _resolveComponent("CabinetSidebar")!
  const _component_CabinetHeader = _resolveComponent("CabinetHeader")!
  const _component_CabinetFooter = _resolveComponent("CabinetFooter")!
  const _component_CabinetBody = _resolveComponent("CabinetBody")!
  const _component_DrawerContainer = _resolveComponent("DrawerContainer")!

  return (_openBlock(), _createBlock(_component_DrawerContainer, {
    "condense-checker": $setup.sizeChecker,
    "full-width": true,
    condensable: true
  }, {
    element: _withCtx(({ condensed, condensable, opened, toggle, close, open }) => [
      _createVNode(_component_CabinetSidebar, {
        condensed: condensed && condensable,
        opened: !condensable && opened || false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_Transition, { name: "appear-immediate" }, {
              default: _withCtx(() => [
                (!(condensed && condensable))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("a", {
                        class: "ds-link ds-link--appearance_block",
                        href: $setup.indexPageUrl
                      }, [
                        _createElementVNode("img", {
                          class: "logo",
                          src: $setup.logoCabinet || '@/assets/logo_cabinet.svg',
                          alt: _ctx.$t('Logo cabinet alt')
                        }, null, 8, _hoisted_4)
                      ], 8, _hoisted_3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "cabinet-sidebar__drawer-receiver",
                onClick: _withModifiers(toggle, ["prevent"])
              }, [
                _createVNode(_Transition, {
                  name: "appear-immediate",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (condensable && !condensed)
                      ? (_openBlock(), _createBlock(_component_AppIcon, {
                          key: "i-sidebar-collapse",
                          size: "xl",
                          name: "i-sidebar-collapse"
                        }))
                      : (condensable && condensed)
                        ? (_openBlock(), _createBlock(_component_AppIcon, {
                            key: "i-sidebar-expand",
                            size: "xl",
                            name: "i-sidebar-expand"
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ], 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("button", {
            class: "cabinet-sidebar__close-button",
            type: "button",
            "aria-label": _ctx.$t('Close'),
            onClick: toggle
          }, [
            _createVNode(_component_AppIcon, {
              "aria-hidden": "true",
              name: "i-close",
              size: "lg"
            })
          ], 8, _hoisted_7)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_CabinetSidebarMenu, {
            sections: $setup.navigation.sections,
            condensed: condensed && condensable,
            opened: false
          }, {
            prepend: _withCtx(() => [
              ((condensed && condensable))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      class: "sidebar-back-to-site",
                      href: $setup.indexPageUrl
                    }, [
                      _createVNode(_component_i_external_link, { class: "sidebar-back-to-site__icon" }),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("Back to site")), 1)
                    ], 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]),
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["cabinet-sidebar-menu-element", { 'is-condensed': condensed && condensable }]),
                  ref: "logoutMenuItemRef",
                  onMouseover: _cache[1] || (_cache[1] = ($event: any) => ($setup.openCondensedMenuItem($setup.logoutMenuItemRef))),
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => ($setup.closeCondensedMenuItem($setup.logoutMenuItemRef)))
                }, [
                  _createElementVNode("a", {
                    class: "cabinet-sidebar-menu-element__link cabinet-sidebar-menu-link",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.logout()), ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_AppIcon, {
                        size: "md",
                        name: 'i-logout'
                      })
                    ]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("Log out")), 1)
                  ])
                ], 34)
              ])
            ]),
            _: 2
          }, 1032, ["sections", "condensed"])
        ]),
        _: 2
      }, 1032, ["condensed", "opened"])
    ]),
    content: _withCtx(({ condensed, condensable, opened, toggle, open, close }) => [
      _createVNode(_component_CabinetBody, null, {
        header: _withCtx(() => [
          _createVNode(_component_CabinetHeader)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_CabinetFooter)
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}